import _ from 'underscore'

import httpClient from '@src/services/http.service.js'

export const state = {
  categories: []
}

export const getters = {
  getCategoryContent: state => (id) =>  {
    const category = _.find(state.categories, category => category._id === id)
    return category.content
  },
  categories: state => state.categories.filter(cat => !cat.isTour),
  tourCategories: state => state.categories.filter(cat => cat.isTour)
}

export const mutations = {
  SET_CATEGORIES: (state, categories) => {
    state.categories = categories
  }
}

export const actions = {
  fetchCategories: ({ commit }) => {
    httpClient.get('category')
      .then(({ data }) => {
        commit('SET_CATEGORIES', data)
      })
      .catch(error => {
        console.error(error.message)
      })
  }
}
